import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { firestore } from './../../firebase/firebase';
import { User } from '../../models/User';
import { UserStation } from '../../models/UserStation';
import { ConfirmUser } from '../../models/ConfirmUser';

export const GET_USERS = 'GET_USERS';
export const GET_CONFIRM_USERS = 'GET_CONFIRM_USERS';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const GET_USER_STATIONS = 'GET_USER_STATIONS';

export interface GetUserActionType {
  type: typeof GET_USERS;
  payload: {
    users: User[];
  };
}

export interface GetConfirmUsersActionType {
  type: typeof GET_CONFIRM_USERS;
  payload: {
    confirmUsers: ConfirmUser[];
  };
}

export interface GetUserDetailsActionType {
  type: typeof GET_USER_DETAILS;
  payload: {
    userDetails: User;
  };
}

export interface GetUserStationsActionType {
  type: typeof GET_USER_STATIONS;
  payload: {
    userStations: UserStation[];
  };
}

export type UserActionTypes =
  | GetUserActionType
  | GetUserDetailsActionType
  | GetUserStationsActionType
  | GetConfirmUsersActionType;

const getUsersAction = (users: User[]): GetUserActionType => {
  return {
    type: 'GET_USERS',
    payload: {
      users,
    },
  };
};

const getConfirmUsersAction = (
  users: ConfirmUser[]
): GetConfirmUsersActionType => {
  console.log('confirmUser', users);

  return {
    type: 'GET_CONFIRM_USERS',
    payload: {
      confirmUsers: users,
    },
  };
};

const getUserDetailsAction = (user: User): GetUserDetailsActionType => {
  return {
    type: 'GET_USER_DETAILS',
    payload: {
      userDetails: user,
    },
  };
};

const getUserStationsAction = (
  userStations: UserStation[]
): GetUserStationsActionType => {
  return {
    type: 'GET_USER_STATIONS',
    payload: {
      userStations: userStations,
    },
  };
};

export const getUserDetails = (uid: string) => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    firestore
      .collection('users')
      .doc(uid)
      .get()
      .then((doc) => {
        return new User(
          doc.data()?.uid,
          doc.data()?.name,
          doc.data()?.icNumber,
          doc.data()?.contactNumber,
          doc.data()?.email,
          undefined,
          undefined,
          doc.data()?.healthStatus ? doc.data()?.healthStatus : 'green',
          doc.data()?.verificationStatus
            ? doc.data()?.verificationStatus
            : undefined,
          doc.data()?.icImageUrl,
          doc.data()?.selfieImageUrl,
          doc.data()?.address,
          doc.data()?.postcode,
          doc.data()?.state
        );
      })
      .then((user) => {
        dispatch(getUserDetailsAction(user));

        return firestore
          .collection('users')
          .doc(uid)
          .collection('stations')
          .orderBy('timestamp', 'desc')
          .get();
      })
      .then((snapshot) => {
        return snapshot.docs.map((doc) => {
          const userStation = new UserStation(
            doc.id,
            doc.data().stationId,
            doc.data().name,
            doc.data().address,
            doc.data().postcode,
            doc.data().state,
            doc.data().timestamp.toDate()
          );

          console.log(userStation);

          return userStation;
        });
      })
      .then((userStations) => {
        dispatch(getUserStationsAction(userStations));
      });
  };
};

export const getConfirmUsers = () => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    firestore.collection('red').onSnapshot(function (snapshot) {
      const users = snapshot.docs.map(
        (doc) =>
          new ConfirmUser(
            doc.id,
            doc.data().name,
            doc.data().email,
            doc.data().icNumber,
            doc.data().contactNumber,
            doc.data().address,
            doc.data().postcode,
            doc.data().state
          )
      );

      dispatch(getConfirmUsersAction(users));
    });
  };
};

export const getUsers = () => {
  return (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    return firestore
      .collection('users')
      .where('role', '==', 'normal')
      .orderBy('name', 'asc')
      .onSnapshot(function (snapshot) {
        const users = snapshot.docs.map(
          (doc) =>
            new User(
              doc.data().uid,
              doc.data().name,
              doc.data().icNumber,
              doc.data().contactNumber,
              doc.data().email,
              undefined,
              undefined,
              doc.data().healthStatus ? doc.data().healthStatus : 'green',
              doc.data().verificationStatus
                ? doc.data().verificationStatus
                : undefined,
              doc.data().icImageUrl,
              doc.data().selfieImageUrl
            )
        );

        dispatch(getUsersAction(users));
      });
  };
};
